export enum AppointmentType {
  OUT_OF_OFFICE = 'ooo',
  EVENT = 'event',
  MANUAL = 'manual',
}
